import { useEditor } from '@smartfire/js-block-engine';
import clsx from 'clsx';
import Button from '../../button/block';
import style from './style.module.scss';

export const HomeTileExcerpt = ({
    post,
    buttonText,
    big = false,
    animate = false,
    onMouseEnter,
    onMouseLeave,
    isNotHover,
}) => {
    const { isEditing } = useEditor();
    const Wrapper = !isEditing ? 'a' : 'div';

    const formatText = () => {
        var words = post.title.split(' ');
        if (words.length === 2) return post.title.replace(' ', '<br/>');
        else return post.title;
    };

    return (
        <div
            className={clsx(style.block, big && style.blockBigger)}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <Wrapper
                href={!isEditing ? post.link : undefined}
                className={clsx(style.imageContainer, animate && style.withHover)}
            >
                {post.imageUrl && <img className={style.image} alt={post.title} src={post.imageUrl} />}
                <div className={clsx(style.after, isNotHover && style.notHover)} />
            </Wrapper>

            <div className={style.bottomContainer}>
                <div>
                    {post.taxonomy && <div className={style.taxonomy}>{post.taxonomy}</div>}
                    <h3 dangerouslySetInnerHTML={{ __html: formatText() }} />
                </div>
                <div className={style.excerpt} dangerouslySetInnerHTML={{ __html: post.excerpt }} />
                <Button
                    classNames={style.button}
                    text={buttonText}
                    link={!isEditing ? post.link : undefined}
                    aspect="contained"
                    position={'left'}
                    backgroundContained={style.green}
                    colorContained={style.blue}
                    inspector={false}
                />
            </div>
        </div>
    );
};
